export default "__VITE_ASSET__CcYNWVEn__"